import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Button,
  CircularProgress,
  Divider,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton
} from '@material-ui/core';
import {
  PictureAsPdf as PdfIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
  Assignment as AssignmentIcon,
  Notifications as NotificationsIcon,
  Email as EmailIcon,
  VpnKey as VpnKeyIcon,
  CheckCircle as CheckCircleIcon,
  Create as CreateIcon,
  OpenInNew as OpenInNewIcon,
  Send as SendIcon,
  History as HistoryIcon,
  CheckCircleOutline as SuccessIcon,
  ErrorOutline as ErrorIcon,
  Cancel as CancelIcon,
  PersonAdd as PersonAddIcon,
  MoreVert as MoreVertIcon,
  Delete as DeleteIcon,
  Warning as WarningIcon
} from '@material-ui/icons';
import { solicitudDetalleService } from '../../services';

const SeccionGeneral = ({ solicitud, tipo, onSolicitudUpdate }) => {
  const [downloadingPdf, setDownloadingPdf] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Estado para el menú de notificaciones
  const [notificacionesAnchorEl, setNotificacionesAnchorEl] = useState(null);
  const [enviandoBienvenida, setEnviandoBienvenida] = useState(false);

  // Estado para el diálogo de datos de acceso
  const [datosAccesoDialogOpen, setDatosAccesoDialogOpen] = useState(false);
  const [datosAccesoForm, setDatosAccesoForm] = useState({
    usuario: '',
    clave: '',
    correosElectronicos: ''
  });
  const [enviandoDatosAcceso, setEnviandoDatosAcceso] = useState(false);

  // Estado para el diálogo de aprobar
  const [aprobarDialogOpen, setAprobarDialogOpen] = useState(false);
  const [aprobarMotivo, setAprobarMotivo] = useState('');
  const [aprobarIdCuenta, setAprobarIdCuenta] = useState('');
  const [aprobando, setAprobando] = useState(false);

  // Estado para firma digital
  const [firmaDigitalDialogOpen, setFirmaDigitalDialogOpen] = useState(false);
  const [firmaDigitalData, setFirmaDigitalData] = useState(null);
  const [firmaDigitalLoading, setFirmaDigitalLoading] = useState(false);
  const [firmaDigitalNotFound, setFirmaDigitalNotFound] = useState(false);

  // Estado para enviar firma digital
  const [enviarFirmaDialogOpen, setEnviarFirmaDialogOpen] = useState(false);
  const [emailsDisponibles, setEmailsDisponibles] = useState([]);
  const [emailsSeleccionados, setEmailsSeleccionados] = useState([]);
  const [enviandoFirma, setEnviandoFirma] = useState(false);

  // Estado para cancelar firma digital
  const [cancelarFirmaDialogOpen, setCancelarFirmaDialogOpen] = useState(false);
  const [razonCancelacion, setRazonCancelacion] = useState('');
  const [cancelandoFirma, setCancelandoFirma] = useState(false);
  const [descargandoDocumentoFirmado, setDescargandoDocumentoFirmado] = useState(false);

  // Estado para auditoría
  const [auditoriaDialogOpen, setAuditoriaDialogOpen] = useState(false);
  const [auditoriaData, setAuditoriaData] = useState([]);
  const [auditoriaLoading, setAuditoriaLoading] = useState(false);

  // Estado para asignar productor
  const [productorDialogOpen, setProductorDialogOpen] = useState(false);
  const [productores, setProductores] = useState([]);
  const [productoresLoading, setProductoresLoading] = useState(false);
  const [productorSeleccionado, setProductorSeleccionado] = useState(null);
  const [asignandoProductor, setAsignandoProductor] = useState(false);

  // Estado para el menú de acciones
  const [accionesAnchorEl, setAccionesAnchorEl] = useState(null);

  // Estado para eliminar solicitud
  const [eliminarDialogOpen, setEliminarDialogOpen] = useState(false);
  const [eliminando, setEliminando] = useState(false);

  // Estado para cambiar a incompleta
  const [cambiandoIncompleta, setCambiandoIncompleta] = useState(false);

  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'APROBADA':
        return { backgroundColor: '#4caf50', color: '#fff' };
      case 'PENDIENTE':
        return { backgroundColor: '#ff9800', color: '#fff' };
      case 'RECHAZADA':
        return { backgroundColor: '#f44336', color: '#fff' };
      case 'EN_REVISION':
        return { backgroundColor: '#2196f3', color: '#fff' };
      default:
        return { backgroundColor: '#9e9e9e', color: '#fff' };
    }
  };

  const handleDescargarPdf = async () => {
    if (!solicitud?.id) return;

    try {
      setDownloadingPdf(true);
      setError('');
      setSuccess('');

      const blob = await solicitudDetalleService.getSolicitudPdf(solicitud.id);

      // Crear URL del blob y descargar
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `solicitud_${solicitud.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error descargando PDF:', err);
      setError('Error al descargar el PDF. Intente nuevamente.');
    } finally {
      setDownloadingPdf(false);
    }
  };

  // Handlers para el menú de notificaciones
  const handleNotificacionesClick = (event) => {
    setNotificacionesAnchorEl(event.currentTarget);
  };

  const handleNotificacionesClose = () => {
    setNotificacionesAnchorEl(null);
  };

  // Handler para enviar mail de bienvenida
  const handleEnviarBienvenida = async () => {
    handleNotificacionesClose();
    if (!solicitud?.id) return;

    try {
      setEnviandoBienvenida(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.enviarMailBienvenida(solicitud.id);
      setSuccess('Mail de bienvenida enviado correctamente.');
    } catch (err) {
      console.error('Error enviando mail de bienvenida:', err);
      setError('Error al enviar el mail de bienvenida. Intente nuevamente.');
    } finally {
      setEnviandoBienvenida(false);
    }
  };

  // Handlers para el diálogo de datos de acceso
  const handleOpenDatosAccesoDialog = () => {
    handleNotificacionesClose();
    setDatosAccesoForm({
      usuario: '',
      clave: '',
      correosElectronicos: ''
    });
    setDatosAccesoDialogOpen(true);
  };

  const handleCloseDatosAccesoDialog = () => {
    setDatosAccesoDialogOpen(false);
    setDatosAccesoForm({
      usuario: '',
      clave: '',
      correosElectronicos: ''
    });
  };

  const handleDatosAccesoFormChange = (field) => (event) => {
    setDatosAccesoForm(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleEnviarDatosAcceso = async () => {
    if (!solicitud?.id) return;

    // Validaciones
    if (!datosAccesoForm.usuario.trim()) {
      setError('El usuario es requerido.');
      return;
    }
    if (!datosAccesoForm.clave.trim()) {
      setError('La contraseña es requerida.');
      return;
    }
    if (!datosAccesoForm.correosElectronicos.trim()) {
      setError('Los correos electrónicos son requeridos.');
      return;
    }

    try {
      setEnviandoDatosAcceso(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.enviarMailDatosAcceso(
        solicitud.id,
        datosAccesoForm.usuario.trim(),
        datosAccesoForm.clave.trim(),
        datosAccesoForm.correosElectronicos.trim()
      );

      setSuccess('Mail con datos de acceso enviado correctamente.');
      handleCloseDatosAccesoDialog();
    } catch (err) {
      console.error('Error enviando mail de datos de acceso:', err);
      setError('Error al enviar el mail de datos de acceso. Intente nuevamente.');
    } finally {
      setEnviandoDatosAcceso(false);
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '-';
    try {
      return new Date(fecha).toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return fecha;
    }
  };

  const isDatosAccesoFormValid = () => {
    return (
      datosAccesoForm.usuario.trim() !== '' &&
      datosAccesoForm.clave.trim() !== '' &&
      datosAccesoForm.correosElectronicos.trim() !== ''
    );
  };

  // Handlers para aprobar solicitud
  const handleOpenAprobarDialog = () => {
    setAprobarMotivo('');
    setAprobarIdCuenta('');
    setAprobarDialogOpen(true);
  };

  const handleCloseAprobarDialog = () => {
    setAprobarDialogOpen(false);
    setAprobarMotivo('');
    setAprobarIdCuenta('');
    setError(''); // Limpiar error al cerrar el diálogo
  };

  // Verificar si el estado requiere motivo (diferente de FIRMADO)
  const requiereMotivo = () => {
    return solicitud?.estado !== 'FIRMADO';
  };

  const handleAprobarSolicitud = async () => {
    if (!solicitud?.id) return;

    // Validar ID de cuenta (siempre requerido)
    if (!aprobarIdCuenta.trim()) {
      setError('El número de cuenta es requerido.');
      return;
    }

    // Validar motivo solo si el estado no es FIRMADO
    if (requiereMotivo() && !aprobarMotivo.trim()) {
      setError('El motivo es requerido cuando el estado no es FIRMADO.');
      return;
    }

    try {
      setAprobando(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.aprobarSolicitud(
        solicitud.id,
        requiereMotivo() ? aprobarMotivo.trim() : '',
        aprobarIdCuenta.trim()
      );

      setSuccess('Solicitud aprobada correctamente.');
      handleCloseAprobarDialog();

      // Recargar los datos de la solicitud
      if (onSolicitudUpdate) {
        setTimeout(async () => {
          await onSolicitudUpdate();
          setSuccess(''); // Limpiar mensaje después de actualizar
        }, 2000);
      } else {
        // Fallback: recargar página si no hay callback
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      }
    } catch (err) {
      console.error('Error aprobando solicitud:', err);
      // Mostrar el mensaje de error del backend si está disponible
      const errorMessage = err.message || 'Error al aprobar la solicitud. Intente nuevamente.';
      setError(errorMessage);
    } finally {
      setAprobando(false);
    }
  };

  // Handlers para firma digital
  const getEstadoFirmaColor = (estado) => {
    switch (estado) {
      case 'COMPLETO':
        return { backgroundColor: '#4caf50', color: '#fff' };
      case 'PENDIENTE':
        return { backgroundColor: '#ff9800', color: '#fff' };
      case 'INCOMPLETO':
        return { backgroundColor: '#2196f3', color: '#fff' };
      case 'CANCELADO':
        return { backgroundColor: '#f44336', color: '#fff' };
      default:
        return { backgroundColor: '#9e9e9e', color: '#fff' };
    }
  };

  const cargarEmailsDisponibles = async () => {
    const emails = new Set();

    try {
      // Obtener email del titular (datos principales)
      if (tipo === 'INDIVIDUO') {
        const datosPrincipales = await solicitudDetalleService.getDatosPrincipalesIndividuo(solicitud.id);
        if (datosPrincipales?.correoElectronico) {
          emails.add(datosPrincipales.correoElectronico);
        }

        // Obtener co-titulares
        try {
          const coTitulares = await solicitudDetalleService.getCoTitularesIndividuo(solicitud.id);
          if (Array.isArray(coTitulares)) {
            coTitulares.forEach(ct => {
              const email = ct?.datosPrincipales?.correoElectronico || ct?.correoElectronico;
              if (email) emails.add(email);
            });
          }
        } catch (e) {
          console.log('No se pudieron cargar co-titulares');
        }
      } else {
        // Empresa
        const datosPrincipales = await solicitudDetalleService.getDatosPrincipalesEmpresa(solicitud.id);
        if (datosPrincipales?.correoElectronico) {
          emails.add(datosPrincipales.correoElectronico);
        }

        // Obtener firmantes
        try {
          const firmantes = await solicitudDetalleService.getFirmantesEmpresa(solicitud.id);
          const listaFirmantes = Array.isArray(firmantes) ? firmantes : firmantes?.firmantes || [];
          listaFirmantes.forEach(f => {
            const email = f?.datosPrincipales?.correoElectronico || f?.correoElectronico;
            if (email) emails.add(email);
          });
        } catch (e) {
          console.log('No se pudieron cargar firmantes');
        }
      }
    } catch (e) {
      console.error('Error cargando emails:', e);
    }

    return Array.from(emails);
  };

  const handleOpenFirmaDigital = async () => {
    if (!solicitud?.id) return;

    try {
      setFirmaDigitalLoading(true);
      setError('');
      setFirmaDigitalNotFound(false);
      setFirmaDigitalData(null);

      const data = await solicitudDetalleService.getEstadoFirmaDigital(solicitud.id);

      if (data.notFound) {
        // No existe firma digital, mostrar opción de enviar
        setFirmaDigitalNotFound(true);
        const emails = await cargarEmailsDisponibles();
        setEmailsDisponibles(emails);
        setEmailsSeleccionados(emails); // Seleccionar todos por defecto
        setEnviarFirmaDialogOpen(true);
      } else if (data.estado === 'CANCELADO') {
        // Si está cancelado, permitir reenviar
        setFirmaDigitalData(data);
        const emails = await cargarEmailsDisponibles();
        setEmailsDisponibles(emails);
        setEmailsSeleccionados(emails); // Seleccionar todos por defecto
        setEnviarFirmaDialogOpen(true);
      } else {
        // Mostrar estado de firma digital
        setFirmaDigitalData(data);
        setFirmaDigitalDialogOpen(true);
      }
    } catch (err) {
      console.error('Error obteniendo estado de firma digital:', err);
      setError('Error al obtener el estado de la firma digital.');
    } finally {
      setFirmaDigitalLoading(false);
    }
  };

  const handleCloseFirmaDigitalDialog = () => {
    setFirmaDigitalDialogOpen(false);
    setFirmaDigitalData(null);
  };

  const handleCloseEnviarFirmaDialog = () => {
    setEnviarFirmaDialogOpen(false);
    setEmailsDisponibles([]);
    setEmailsSeleccionados([]);
  };

  const handleToggleEmail = (email) => {
    setEmailsSeleccionados(prev => {
      if (prev.includes(email)) {
        return prev.filter(e => e !== email);
      } else {
        return [...prev, email];
      }
    });
  };

  const handleEnviarFirmaDigital = async () => {
    if (!solicitud?.id) return;

    if (emailsSeleccionados.length === 0) {
      setError('Debe seleccionar al menos un correo electrónico.');
      return;
    }

    try {
      setEnviandoFirma(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.enviarFirmaDigital(solicitud.id, emailsSeleccionados);

      setSuccess('Firma digital enviada correctamente.');
      handleCloseEnviarFirmaDialog();
    } catch (err) {
      console.error('Error enviando firma digital:', err);
      setError('Error al enviar la firma digital. Intente nuevamente.');
    } finally {
      setEnviandoFirma(false);
    }
  };

  const handleOpenCancelarFirmaDialog = () => {
    setRazonCancelacion('');
    setCancelarFirmaDialogOpen(true);
    setError('');
  };

  const handleDescargarDocumentoFirmado = async () => {
    if (!solicitud?.id) return;

    try {
      setDescargandoDocumentoFirmado(true);
      setError('');

      const blob = await solicitudDetalleService.descargarDocumentoFirmado(solicitud.id);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `documento_firmado_${solicitud.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error descargando documento firmado:', err);
      setError('Error al descargar el documento firmado. Intente nuevamente.');
    } finally {
      setDescargandoDocumentoFirmado(false);
    }
  };

  const handleCloseCancelarFirmaDialog = () => {
    setCancelarFirmaDialogOpen(false);
    setRazonCancelacion('');
    setError('');
  };

  const handleCancelarFirmaDigital = async () => {
    if (!solicitud?.id) return;

    if (!razonCancelacion.trim()) {
      setError('La razón de cancelación es requerida.');
      return;
    }

    try {
      setCancelandoFirma(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.cancelarFirmaDigital(solicitud.id, razonCancelacion.trim());

      setSuccess('Documento cancelado correctamente.');
      handleCloseCancelarFirmaDialog();
      handleCloseFirmaDigitalDialog();

      // Recargar el estado de la firma digital
      await handleOpenFirmaDigital();
    } catch (err) {
      console.error('Error cancelando firma digital:', err);
      const errorMessage = err.message || 'Error al cancelar el documento. Intente nuevamente.';
      setError(errorMessage);
    } finally {
      setCancelandoFirma(false);
    }
  };

  // Handlers para auditoría
  const getTipoAccionLabel = (tipoAccion) => {
    const labels = {
      'CREACION_SOLICITUD': 'Creación de Solicitud',
      'APROBACION_CUENTA': 'Aprobación de Cuenta',
      'ENVIO_CORREO': 'Envío de Correo',
      'ENVIO_FIRMA_DIGITAL': 'Envío de Firma Digital',
      'MODIFICACION_DATOS': 'Modificación de Datos',
      'RECHAZO_SOLICITUD': 'Rechazo de Solicitud',
      'CANCELACION': 'Cancelación'
    };
    return labels[tipoAccion] || tipoAccion;
  };

  const getResultadoColor = (resultado) => {
    switch (resultado) {
      case 'EXITOSO':
        return { backgroundColor: '#4caf50', color: '#fff' };
      case 'FALLIDO':
        return { backgroundColor: '#f44336', color: '#fff' };
      case 'PENDIENTE':
        return { backgroundColor: '#ff9800', color: '#fff' };
      default:
        return { backgroundColor: '#9e9e9e', color: '#fff' };
    }
  };

  const handleOpenAuditoria = async () => {
    if (!solicitud?.id) return;

    try {
      setAuditoriaLoading(true);
      setError('');

      const data = await solicitudDetalleService.getAuditoriaSolicitud(solicitud.id);
      setAuditoriaData(Array.isArray(data) ? data : []);
      setAuditoriaDialogOpen(true);
    } catch (err) {
      console.error('Error obteniendo auditoría:', err);
      setError('Error al obtener el historial de auditoría.');
    } finally {
      setAuditoriaLoading(false);
    }
  };

  const handleCloseAuditoriaDialog = () => {
    setAuditoriaDialogOpen(false);
    setAuditoriaData([]);
  };

  // Handlers para asignar productor
  const handleOpenProductorDialog = async () => {
    try {
      setProductoresLoading(true);
      setError('');

      const data = await solicitudDetalleService.obtenerProductores();
      setProductores(Array.isArray(data) ? data : []);
      setProductorSeleccionado(null);
      setProductorDialogOpen(true);
    } catch (err) {
      console.error('Error obteniendo productores:', err);
      setError('Error al obtener la lista de productores.');
    } finally {
      setProductoresLoading(false);
    }
  };

  const handleCloseProductorDialog = () => {
    setProductorDialogOpen(false);
    setProductores([]);
    setProductorSeleccionado(null);
  };

  const handleAsignarProductor = async () => {
    if (!solicitud?.id || !productorSeleccionado) return;

    try {
      setAsignandoProductor(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.asignarProductor(solicitud.id, productorSeleccionado.id);

      setSuccess(`Productor ${productorSeleccionado.nombres} ${productorSeleccionado.apellidos} asignado correctamente.`);
      handleCloseProductorDialog();

      // Recargar los datos de la solicitud
      if (onSolicitudUpdate) {
        setTimeout(async () => {
          await onSolicitudUpdate();
          setSuccess(''); // Limpiar mensaje después de actualizar
        }, 1000);
      } else {
        // Fallback: recargar página si no hay callback
        window.location.reload();
      }
    } catch (err) {
      console.error('Error asignando productor:', err);
      setError('Error al asignar el productor. Intente nuevamente.');
    } finally {
      setAsignandoProductor(false);
    }
  };

  // Handlers para el menú de acciones
  const handleAccionesClick = (event) => {
    setAccionesAnchorEl(event.currentTarget);
  };

  const handleAccionesClose = () => {
    setAccionesAnchorEl(null);
  };

  const handleAccionAprobar = () => {
    handleAccionesClose();
    handleOpenAprobarDialog();
  };

  const handleAccionAsignarProductor = () => {
    handleAccionesClose();
    handleOpenProductorDialog();
  };

  const handleAccionDescargarPdf = () => {
    handleAccionesClose();
    handleDescargarPdf();
  };

  const handleAccionCambiarIncompleta = () => {
    handleAccionesClose();
    handleCambiarIncompleta();
  };

  // Handler para cambiar estado a incompleta
  const handleCambiarIncompleta = async () => {
    if (!solicitud?.id) return;

    try {
      setCambiandoIncompleta(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.cambiarEstadoIncompleta(solicitud.id);

      setSuccess('Estado cambiado a INCOMPLETA correctamente.');

      // Recargar los datos de la solicitud
      if (onSolicitudUpdate) {
        setTimeout(async () => {
          await onSolicitudUpdate();
          setSuccess(''); // Limpiar mensaje después de actualizar
        }, 1000);
      } else {
        // Fallback: recargar página si no hay callback
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (err) {
      console.error('Error cambiando estado a incompleta:', err);
      const errorMessage = err.message || 'Error al cambiar el estado a INCOMPLETA. Intente nuevamente.';
      setError(errorMessage);
    } finally {
      setCambiandoIncompleta(false);
    }
  };

  // Handlers para eliminar solicitud
  const handleOpenEliminarDialog = () => {
    handleAccionesClose();
    setEliminarDialogOpen(true);
  };

  const handleCloseEliminarDialog = () => {
    setEliminarDialogOpen(false);
  };

  const handleEliminarSolicitud = async () => {
    if (!solicitud?.id) return;

    try {
      setEliminando(true);
      setError('');
      setSuccess('');

      await solicitudDetalleService.eliminarSolicitud(solicitud.id);

      setSuccess('Solicitud eliminada correctamente. Redirigiendo...');
      handleCloseEliminarDialog();

      // Redirigir a la lista de solicitudes
      setTimeout(() => {
        window.location.href = '/solicitudes';
      }, 1500);
    } catch (err) {
      console.error('Error eliminando solicitud:', err);
      setError('Error al eliminar la solicitud. Intente nuevamente.');
    } finally {
      setEliminando(false);
    }
  };

  if (!solicitud) {
    return (
      <Card>
        <CardContent>
          <Typography variant="body1" color="textSecondary">
            No se encontró información de la solicitud.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: '1.5rem' }}>
          Información General
        </Typography>

        <Grid container spacing={3}>
          {/* Información básica */}
          <Grid item xs={12} md={6}>
            <Card variant="outlined" style={{ height: '100%' }}>
              <CardContent>
                <Box display="flex" alignItems="center" marginBottom="1rem">
                  <AssignmentIcon style={{ marginRight: '0.5rem', color: '#1976d2' }} />
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    Datos de la Solicitud
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      ID Solicitud
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      #{solicitud.id}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      Estado
                    </Typography>
                    <Box>
                      <Chip
                        label={solicitud.estado || 'Sin estado'}
                        size="small"
                        style={getEstadoColor(solicitud.estado)}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      Tipo
                    </Typography>
                    <Box display="flex" alignItems="center">
                      {tipo === 'INDIVIDUO' ? (
                        <PersonIcon fontSize="small" style={{ marginRight: '0.25rem', color: '#666' }} />
                      ) : (
                        <BusinessIcon fontSize="small" style={{ marginRight: '0.25rem', color: '#666' }} />
                      )}
                      <Typography variant="body1">
                        {tipo === 'INDIVIDUO' ? 'Individuo' : 'Empresa'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      ID Cuenta
                    </Typography>
                    <Typography variant="body1">
                      {solicitud.idCuenta || '-'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      Productor
                    </Typography>
                    <Typography variant="body1">
                      {solicitud.productor || '-'}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Información del titular */}
          <Grid item xs={12} md={6}>
            <Card variant="outlined" style={{ height: '100%' }}>
              <CardContent>
                <Box display="flex" alignItems="center" marginBottom="1rem">
                  <PersonIcon style={{ marginRight: '0.5rem', color: '#1976d2' }} />
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    Titular / Usuario
                  </Typography>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="caption" color="textSecondary">
                      Nombre / Razón Social
                    </Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      {solicitud.titular || '-'}
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="caption" color="textSecondary">
                      Email Usuario
                    </Typography>
                    <Typography variant="body1">
                      {solicitud.emailUsuarioCargo || '-'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      Fecha de Alta
                    </Typography>
                    <Typography variant="body1">
                      {formatearFecha(solicitud.fechaAlta)}
                    </Typography>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="caption" color="textSecondary">
                      Última Modificación
                    </Typography>
                    <Typography variant="body1">
                      {formatearFecha(solicitud.fechaUltimaModificacion)}
                    </Typography>
                  </Grid>

                  {solicitud.fechaAprobo && (
                    <Grid item xs={6}>
                      <Typography variant="caption" color="textSecondary">
                        Fecha de Aprobación
                      </Typography>
                      <Typography variant="body1">
                        {formatearFecha(solicitud.fechaAprobo)}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider style={{ margin: '2rem 0' }} />

        {/* Botonera de acciones */}
        <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '1rem' }}>
          Acciones
        </Typography>

        {error && (
          <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
            <Typography variant="body2">{error}</Typography>
          </Box>
        )}

        {success && (
          <Box p={2} mb={2} style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px' }}>
            <Typography variant="body2">{success}</Typography>
          </Box>
        )}

        <Box display="flex" flexWrap="wrap" style={{ gap: '1rem' }}>
          {/* Botón Acciones con menú desplegable */}
          <Button
            variant="contained"
            startIcon={(downloadingPdf || aprobando || productoresLoading || cambiandoIncompleta) ? <CircularProgress size={20} color="inherit" /> : <MoreVertIcon />}
            onClick={handleAccionesClick}
            disabled={downloadingPdf || aprobando || productoresLoading || cambiandoIncompleta}
            style={{
              backgroundColor: '#455a64',
              color: '#fff',
              textTransform: 'none'
            }}
          >
            Acciones
          </Button>
          <Menu
            anchorEl={accionesAnchorEl}
            keepMounted
            open={Boolean(accionesAnchorEl)}
            onClose={handleAccionesClose}
          >
            <MenuItem onClick={handleAccionDescargarPdf} disabled={downloadingPdf}>
              <PdfIcon fontSize="small" style={{ marginRight: '0.5rem', color: '#d32f2f' }} />
              Obtener PDF
            </MenuItem>
            <MenuItem onClick={handleAccionAprobar} disabled={aprobando || solicitud?.estado === 'APROBADA'}>
              <CheckCircleIcon fontSize="small" style={{ marginRight: '0.5rem', color: '#4caf50' }} />
              Aprobar
            </MenuItem>
            <MenuItem onClick={handleAccionCambiarIncompleta} disabled={cambiandoIncompleta}>
              <WarningIcon fontSize="small" style={{ marginRight: '0.5rem', color: '#ff9800' }} />
              Cambiar Incompleta
            </MenuItem>
            <MenuItem onClick={handleAccionAsignarProductor} disabled={productoresLoading}>
              <PersonAddIcon fontSize="small" style={{ marginRight: '0.5rem', color: '#ff5722' }} />
              Asignar Productor
            </MenuItem>
          </Menu>

          {/* Botón de Notificaciones con menú desplegable */}
          <Button
            variant="contained"
            startIcon={enviandoBienvenida ? <CircularProgress size={20} color="inherit" /> : <NotificationsIcon />}
            onClick={handleNotificacionesClick}
            disabled={enviandoBienvenida}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              textTransform: 'none'
            }}
          >
            Notificaciones
          </Button>
          <Menu
            anchorEl={notificacionesAnchorEl}
            keepMounted
            open={Boolean(notificacionesAnchorEl)}
            onClose={handleNotificacionesClose}
          >
            <MenuItem onClick={handleEnviarBienvenida}>
              <EmailIcon fontSize="small" style={{ marginRight: '0.5rem' }} />
              Mail de Bienvenida
            </MenuItem>
            <MenuItem onClick={handleOpenDatosAccesoDialog}>
              <VpnKeyIcon fontSize="small" style={{ marginRight: '0.5rem' }} />
              Mail de Datos de Acceso
            </MenuItem>
          </Menu>

          {/* Botón Firma Digital */}
          <Button
            variant="contained"
            startIcon={firmaDigitalLoading ? <CircularProgress size={20} color="inherit" /> : <CreateIcon />}
            onClick={handleOpenFirmaDigital}
            disabled={firmaDigitalLoading}
            style={{
              backgroundColor: '#9c27b0',
              color: '#fff',
              textTransform: 'none'
            }}
          >
            Firma Digital
          </Button>

          {/* Botón Auditoría */}
          <Button
            variant="contained"
            startIcon={auditoriaLoading ? <CircularProgress size={20} color="inherit" /> : <HistoryIcon />}
            onClick={handleOpenAuditoria}
            disabled={auditoriaLoading}
            style={{
              backgroundColor: '#607d8b',
              color: '#fff',
              textTransform: 'none'
            }}
          >
            Auditoría
          </Button>

          {/* Botón Eliminar */}
          <Button
            variant="contained"
            startIcon={eliminando ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
            onClick={handleOpenEliminarDialog}
            disabled={eliminando}
            style={{
              backgroundColor: '#f44336',
              color: '#fff',
              textTransform: 'none'
            }}
          >
            Eliminar
          </Button>
        </Box>

        {/* Diálogo para enviar datos de acceso */}
        <Dialog
          open={datosAccesoDialogOpen}
          onClose={handleCloseDatosAccesoDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Enviar Datos de Acceso</DialogTitle>
          <DialogContent>
            <Box pt={1}>
              <TextField
                fullWidth
                label="Usuario"
                variant="outlined"
                value={datosAccesoForm.usuario}
                onChange={handleDatosAccesoFormChange('usuario')}
                required
                style={{ marginBottom: '1rem' }}
              />
              <TextField
                fullWidth
                label="Contraseña"
                variant="outlined"
                type="password"
                value={datosAccesoForm.clave}
                onChange={handleDatosAccesoFormChange('clave')}
                required
                style={{ marginBottom: '1rem' }}
              />
              <TextField
                fullWidth
                label="Correos Electrónicos"
                variant="outlined"
                value={datosAccesoForm.correosElectronicos}
                onChange={handleDatosAccesoFormChange('correosElectronicos')}
                required
                helperText="Ingrese los correos separados por coma (ej: correo1@email.com, correo2@email.com)"
                multiline
                rows={2}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDatosAccesoDialog} disabled={enviandoDatosAcceso}>
              Cancelar
            </Button>
            <Button
              onClick={handleEnviarDatosAcceso}
              color="primary"
              variant="contained"
              disabled={enviandoDatosAcceso || !isDatosAccesoFormValid()}
              startIcon={enviandoDatosAcceso ? <CircularProgress size={20} color="inherit" /> : null}
            >
              {enviandoDatosAcceso ? 'Enviando...' : 'Enviar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo para aprobar solicitud */}
        <Dialog
          open={aprobarDialogOpen}
          onClose={handleCloseAprobarDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Aprobar Solicitud</DialogTitle>
          <DialogContent>
            <Box pt={1}>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: '1rem' }}>
                ¿Está seguro que desea aprobar la solicitud #{solicitud?.id}?
              </Typography>

              {error && (
                <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
                  <Typography variant="body2">{error}</Typography>
                </Box>
              )}

              <TextField
                fullWidth
                label="Número de Cuenta en AUNESA"
                variant="outlined"
                value={aprobarIdCuenta}
                onChange={(e) => {
                  setAprobarIdCuenta(e.target.value);
                  setError(''); // Limpiar error al cambiar el campo
                }}
                required
                style={{ marginBottom: '1rem' }}
                placeholder="Por favor ingrese el número de cuenta que va a tener en AUNESA"
                helperText="Este campo es obligatorio"
              />

              {requiereMotivo() && (
                <TextField
                  fullWidth
                  label="Motivo de aprobación"
                  variant="outlined"
                  value={aprobarMotivo}
                  onChange={(e) => {
                    setAprobarMotivo(e.target.value);
                    setError(''); // Limpiar error al cambiar el campo
                  }}
                  required
                  multiline
                  rows={3}
                  placeholder="Ingrese el motivo de la aprobación..."
                  helperText={`Requerido porque el estado actual es "${solicitud?.estado}" (diferente de FIRMADO)`}
                />
              )}

              {!requiereMotivo() && (
                <Typography variant="body2" style={{ color: '#4caf50', marginTop: '0.5rem' }}>
                  ✓ El estado es FIRMADO, no se requiere motivo.
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAprobarDialog} disabled={aprobando}>
              Cancelar
            </Button>
            <Button
              onClick={handleAprobarSolicitud}
              variant="contained"
              disabled={aprobando || !aprobarIdCuenta.trim() || (requiereMotivo() && !aprobarMotivo.trim())}
              startIcon={aprobando ? <CircularProgress size={20} color="inherit" /> : <CheckCircleIcon />}
              style={{ backgroundColor: '#4caf50', color: '#fff' }}
            >
              {aprobando ? 'Aprobando...' : 'Aprobar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo para mostrar estado de firma digital */}
        <Dialog
          open={firmaDigitalDialogOpen}
          onClose={handleCloseFirmaDigitalDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <span>Estado de Firma Digital</span>
              {firmaDigitalData?.estado && (
                <Chip
                  label={firmaDigitalData.estado}
                  size="small"
                  style={getEstadoFirmaColor(firmaDigitalData.estado)}
                />
              )}
            </Box>
          </DialogTitle>
          <DialogContent>
            {firmaDigitalData && (
              <Box>
                <Grid container spacing={2} style={{ marginBottom: '1.5rem' }}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="textSecondary">ID Documento</Typography>
                    <Typography variant="body1">{firmaDigitalData.id || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="textSecondary">Título</Typography>
                    <Typography variant="body1">{firmaDigitalData.titulo || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="caption" color="textSecondary">Fecha</Typography>
                    <Typography variant="body1">
                      {firmaDigitalData.fecha ? formatearFecha(firmaDigitalData.fecha) : '-'}
                    </Typography>
                  </Grid>
                  {firmaDigitalData.url && (
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="textSecondary">Documento</Typography>
                      <Box>
                        <Link
                          href={firmaDigitalData.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                        >
                          Ver documento <OpenInNewIcon fontSize="small" />
                        </Link>
                      </Box>
                    </Grid>
                  )}
                  {firmaDigitalData.motivoCancelacion && (
                    <Grid item xs={12}>
                      <Typography variant="caption" color="textSecondary">Motivo de Cancelación</Typography>
                      <Typography variant="body1" style={{ color: '#d32f2f' }}>
                        {firmaDigitalData.motivoCancelacion}
                      </Typography>
                    </Grid>
                  )}
                </Grid>

                {/* Tabla de firmas */}
                {firmaDigitalData.firmas && firmaDigitalData.firmas.length > 0 && (
                  <>
                    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: '0.5rem' }}>
                      Firmas
                    </Typography>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Email</TableCell>
                          <TableCell>Estado</TableCell>
                          <TableCell>Fecha</TableCell>
                          <TableCell>Acciones</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {firmaDigitalData.firmas.map((firma) => (
                          <TableRow key={firma.id}>
                            <TableCell>{firma.email || '-'}</TableCell>
                            <TableCell>
                              <Chip
                                label={firma.estado}
                                size="small"
                                style={getEstadoFirmaColor(firma.estado)}
                              />
                            </TableCell>
                            <TableCell>
                              {firma.fecha ? formatearFecha(firma.fecha) : '-'}
                            </TableCell>
                            <TableCell>
                              {firma.url && (
                                <IconButton
                                  size="small"
                                  href={firma.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <OpenInNewIcon fontSize="small" />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            {firmaDigitalData?.estado === 'PENDIENTE' && (
              <Button
                onClick={handleOpenCancelarFirmaDialog}
                variant="contained"
                style={{ backgroundColor: '#f44336', color: '#fff', marginRight: 'auto' }}
                startIcon={<CancelIcon />}
              >
                Cancelar Documento
              </Button>
            )}
            {firmaDigitalData?.estado === 'CANCELADO' && (
              <Button
                onClick={async () => {
                  handleCloseFirmaDigitalDialog();
                  const emails = await cargarEmailsDisponibles();
                  setEmailsDisponibles(emails);
                  setEmailsSeleccionados(emails);
                  setEnviarFirmaDialogOpen(true);
                }}
                variant="contained"
                style={{ backgroundColor: '#9c27b0', color: '#fff', marginRight: 'auto' }}
                startIcon={<SendIcon />}
              >
                Enviar Firma Digital
              </Button>
            )}
            {firmaDigitalData && (
              <Button
                onClick={handleDescargarDocumentoFirmado}
                variant="contained"
                disabled={descargandoDocumentoFirmado}
                style={{ backgroundColor: '#4caf50', color: '#fff', marginRight: (firmaDigitalData?.estado === 'PENDIENTE' || firmaDigitalData?.estado === 'CANCELADO') ? '0' : 'auto' }}
                startIcon={descargandoDocumentoFirmado ? <CircularProgress size={20} color="inherit" /> : <PdfIcon />}
              >
                {descargandoDocumentoFirmado ? 'Descargando...' : 'Descargar Firmado'}
              </Button>
            )}
            <Button onClick={handleCloseFirmaDigitalDialog}>
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo para enviar firma digital */}
        <Dialog
          open={enviarFirmaDialogOpen}
          onClose={handleCloseEnviarFirmaDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Enviar Firma Digital</DialogTitle>
          <DialogContent>
            <Box pt={1}>
              <Typography variant="body2" color="textSecondary" style={{ marginBottom: '1rem' }}>
                {firmaDigitalData?.estado === 'CANCELADO'
                  ? 'La firma digital fue cancelada. Seleccione los correos electrónicos a los que se enviará nuevamente la solicitud de firma:'
                  : 'No existe una firma digital para esta solicitud. Seleccione los correos electrónicos a los que se enviará la solicitud de firma:'}
              </Typography>

              {emailsDisponibles.length === 0 ? (
                <Typography variant="body2" style={{ color: '#f44336' }}>
                  No se encontraron correos electrónicos asociados a esta solicitud.
                </Typography>
              ) : (
                <Box>
                  {emailsDisponibles.map((email) => (
                    <FormControlLabel
                      key={email}
                      control={
                        <Checkbox
                          checked={emailsSeleccionados.includes(email)}
                          onChange={() => handleToggleEmail(email)}
                          color="primary"
                        />
                      }
                      label={email}
                      style={{ display: 'block' }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEnviarFirmaDialog} disabled={enviandoFirma}>
              Cancelar
            </Button>
            <Button
              onClick={handleEnviarFirmaDigital}
              variant="contained"
              disabled={enviandoFirma || emailsSeleccionados.length === 0}
              startIcon={enviandoFirma ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
              style={{ backgroundColor: '#9c27b0', color: '#fff' }}
            >
              {enviandoFirma ? 'Enviando...' : 'Enviar Firma Digital'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo para cancelar firma digital */}
        <Dialog
          open={cancelarFirmaDialogOpen}
          onClose={handleCloseCancelarFirmaDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <CancelIcon style={{ marginRight: '0.5rem', color: '#f44336' }} />
              Cancelar Documento
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box pt={1}>
              {error && (
                <Box p={2} mb={2} style={{ backgroundColor: '#ffebee', color: '#c62828', borderRadius: '4px' }}>
                  <Typography variant="body2">{error}</Typography>
                </Box>
              )}
              <Typography variant="body1" style={{ marginBottom: '1rem' }}>
                ¿Está seguro que desea cancelar el documento de firma digital?
              </Typography>
              <Typography variant="body2" color="error" style={{ marginBottom: '1rem' }}>
                <strong>Atención:</strong> Esta acción cancelará el proceso de firma digital para esta solicitud.
              </Typography>
              <TextField
                fullWidth
                label="Razón de cancelación"
                variant="outlined"
                value={razonCancelacion}
                onChange={(e) => {
                  setRazonCancelacion(e.target.value);
                  setError(''); // Clear error on change
                }}
                required
                multiline
                rows={4}
                placeholder="Ingrese la razón de cancelación..."
                helperText="Este campo es obligatorio"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseCancelarFirmaDialog} disabled={cancelandoFirma}>
              Cancelar
            </Button>
            <Button
              onClick={handleCancelarFirmaDigital}
              variant="contained"
              disabled={cancelandoFirma || !razonCancelacion.trim()}
              startIcon={cancelandoFirma ? <CircularProgress size={20} color="inherit" /> : <CancelIcon />}
              style={{ backgroundColor: '#f44336', color: '#fff' }}
            >
              {cancelandoFirma ? 'Cancelando...' : 'Confirmar Cancelación'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo para auditoría */}
        <Dialog
          open={auditoriaDialogOpen}
          onClose={handleCloseAuditoriaDialog}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <HistoryIcon style={{ marginRight: '0.5rem' }} />
              Historial de Auditoría - Solicitud #{solicitud?.id}
            </Box>
          </DialogTitle>
          <DialogContent>
            {auditoriaData.length === 0 ? (
              <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: '2rem' }}>
                No hay registros de auditoría para esta solicitud.
              </Typography>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 600 }}>Fecha</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Acción</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Usuario</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Resultado</TableCell>
                    <TableCell style={{ fontWeight: 600 }}>Mensaje</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {auditoriaData.map((auditoria) => (
                    <TableRow key={auditoria.id}>
                      <TableCell style={{ whiteSpace: 'nowrap' }}>
                        {auditoria.fecha ? formatearFecha(auditoria.fecha) : '-'}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={getTipoAccionLabel(auditoria.tipoAccion)}
                          size="small"
                          variant="outlined"
                          style={{ fontSize: '0.75rem' }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" style={{ fontWeight: 500 }}>
                            {auditoria.usuario?.username || '-'}
                          </Typography>
                          {auditoria.usuario?.email && (
                            <Typography variant="caption" color="textSecondary">
                              {auditoria.usuario.email}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          icon={auditoria.resultado === 'EXITOSO' ? <SuccessIcon style={{ fontSize: '1rem' }} /> : <ErrorIcon style={{ fontSize: '1rem' }} />}
                          label={auditoria.resultado}
                          size="small"
                          style={getResultadoColor(auditoria.resultado)}
                        />
                      </TableCell>
                      <TableCell style={{ maxWidth: '400px' }}>
                        <Typography variant="body2" style={{ wordBreak: 'break-word' }}>
                          {auditoria.mensaje || '-'}
                        </Typography>
                        {auditoria.detalles && (
                          <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: '0.25rem' }}>
                            {auditoria.detalles}
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAuditoriaDialog}>
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Diálogo para asignar productor */}
        <Dialog
          open={productorDialogOpen}
          onClose={handleCloseProductorDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <PersonAddIcon style={{ marginRight: '0.5rem' }} />
              Asignar Productor
            </Box>
          </DialogTitle>
          <DialogContent>
            {productores.length === 0 ? (
              <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: '2rem' }}>
                No hay productores disponibles.
              </Typography>
            ) : (
              <Box>
                <Typography variant="body2" color="textSecondary" style={{ marginBottom: '1rem' }}>
                  Seleccione un productor para asignar a la solicitud #{solicitud?.id}:
                </Typography>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox"></TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Nombre</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Email</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productores.map((productor) => (
                      <TableRow
                        key={productor.id}
                        hover
                        onClick={() => setProductorSeleccionado(productor)}
                        selected={productorSeleccionado?.id === productor.id}
                        style={{ cursor: 'pointer' }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={productorSeleccionado?.id === productor.id}
                            onChange={() => setProductorSeleccionado(productor)}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          {productor.nombres} {productor.apellidos}
                        </TableCell>
                        <TableCell>
                          {productor.correoElectronico || '-'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseProductorDialog} disabled={asignandoProductor}>
              Cerrar
            </Button>
            <Button
              onClick={handleAsignarProductor}
              variant="contained"
              disabled={asignandoProductor || !productorSeleccionado}
              startIcon={asignandoProductor ? <CircularProgress size={20} color="inherit" /> : <PersonAddIcon />}
              style={{ backgroundColor: '#ff5722', color: '#fff' }}
            >
              {asignandoProductor ? 'Asignando...' : 'Asignar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog de Eliminar Solicitud */}
        <Dialog
          open={eliminarDialogOpen}
          onClose={handleCloseEliminarDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <DeleteIcon style={{ marginRight: '0.5rem', color: '#f44336' }} />
              Eliminar Solicitud
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box pt={1}>
              <Typography variant="body1" style={{ marginBottom: '1rem' }}>
                ¿Está seguro que desea eliminar la solicitud <strong>#{solicitud?.id}</strong>?
              </Typography>
              <Typography variant="body2" color="error" style={{ marginBottom: '1rem' }}>
                <strong>Atención:</strong> Esta acción no se puede deshacer. Se eliminarán todos los datos asociados a esta solicitud.
              </Typography>
              {solicitud?.titular && (
                <Typography variant="body2" color="textSecondary">
                  Titular: <strong>{solicitud.titular}</strong>
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEliminarDialog} disabled={eliminando}>
              Cancelar
            </Button>
            <Button
              onClick={handleEliminarSolicitud}
              variant="contained"
              disabled={eliminando}
              startIcon={eliminando ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
              style={{ backgroundColor: '#f44336', color: '#fff' }}
            >
              {eliminando ? 'Eliminando...' : 'Eliminar'}
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default SeccionGeneral;
